var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"slide",class:`slide ${_vm.isInView ? 'in-view' : ''} ${_vm.shouldRender ? 'visible' : ''}`,style:(_vm.styleString)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }